export const sortByNumberAsc = (a: { name: string }, b: { name: string }) =>
  parseInt(a.name, 10) - parseInt(b.name, 10)
